import React from 'react';
import config from 'config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'NOTICEBOARD/CommonResources/DeleteModal/deletemodal.css';

class DeleteModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmText: '',
            instituteId: config.institute_id,
            deleteWarning: ''
        };
        this.initialState = this.state;
    }

    // METHOD TO GET CONFIRMATION TEXT
    confirmDelete = (event) => {
        if(event.target.value.length > 1){
            if(event.target.value == 'DELETE PERMANENTLY') {
                this.setState({
                    deleteWarning: ''
                });
            }else {
                this.setState({
                    deleteWarning: `Please enter "DELETE PERMANENTLY" to delete selected ${this.props.deleteKey.toLowerCase()}(s).`
                });
            }
        }else {
            this.setState({
                deleteWarning: `Please enter "DELETE PERMANENTLY" to delete selected ${this.props.deleteKey.toLowerCase()}(s).`
            });
        }
        this.setState({
            confirmText: event.target.value
        });
    }

    // METHOD TO DELETE SALARY COMPONENT
    deleteComponent = async (event) => {
        if(this.state.confirmText.length > 1) {
            if(this.state.confirmText == 'DELETE PERMANENTLY') {
                this.props.deleteComponent();
            }else {
                this.setState ({
                    deleteWarning: 'Please enter "DELETE PERMANENTLY" to delete selected component(s).'
                });
            }
        }else {
            this.setState ({
                deleteWarning: 'Please enter "DELETE PERMANENTLY" to delete selected component(s).'
            });
        }
    }

    deleteCancel = () => {
        this.setState(
            this.initialState
        );
        this.props.visibility();
    }

    render() {
        return(
            <div className={this.props.showModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header modalHeader">
                            <div className="iconContainer" style={{ backgroundColor: '#FF0000' }}>
                                <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="lg" color='#FFFFFF' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Are You Sure ?</h3>
                        </div>
                        <div className="modal-body deleteModalBody">
                            <p className="note-text">
                                {this.props.deleteKey} once deleted, cannot be retrieved. All data associated with the {this.props.deleteKey.toLowerCase()} will be deleted permanently.
                            </p>

                            <p className="deleteConfirmationText">If you want to delete the {this.props.deleteKey.toLowerCase()} , type <span style={{ fontWeight: 'bold' }}>DELETE PERMANENTLY</span> in block/capital letters in below input text for confirmation.</p>
                            <input 
                                type="text"
                                className="form-control" 
                                value={this.state.deleteMultipleModalText} 
                                onChange={(e) => this.confirmDelete(e)} 
                                placeholder="Please type DELETE PERMANENTLY" 
                                maxLength={18} 
                                onPaste={(e) => e.preventDefault()} 
                            />

                            <p style={{ 
                                display: this.state.deleteWarning.length > 0 ? 'block' : 'none', 
                                color: 'red', 
                                fontSize: 14, 
                                marginTop: 5 }}
                            >{this.state.deleteWarning}</p>

                        </div>

                        <div className="modal-footer">

                            <div id="addAssetButtonContainer">
                                <button className="btn delete-outline-button waves-effect" onClick={() => this.deleteComponent()}>Yes</button>

                                <button className="btn delete-primary-button" onClick={() => this.deleteCancel()}>No</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteModal;